import $ from 'jquery';
import {nameToCamelCase, replaceStopWords, replaceSpecialChars} from '../../src/libs/common-library';
import {putDataInDevCenterDataStore} from '../app/store';

var languagePrefixApiCategoryCoreServices = "";
var fileUrl = "";
var forbiddenFileUrl = "";
var c1 = 0;
var c2 = 0;
var c3 = 0;

   // Create Base64 Object
    var Base64 = {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        encode: function(e) {
            var t = "";
            var n, r, i, s, o, u, a;
            var f = 0;
            e = Base64._utf8_encode(e);
            while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
            }
            return t
        },
        decode: function(e) {
            var t = "";
            var n, r, i;
            var s, o, u, a;
            var f = 0;
            e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            while (f < e.length) {
                s = this._keyStr.indexOf(e.charAt(f++));
                o = this._keyStr.indexOf(e.charAt(f++));
                u = this._keyStr.indexOf(e.charAt(f++));
                a = this._keyStr.indexOf(e.charAt(f++));
                n = s << 2 | o >> 4;
                r = (o & 15) << 4 | u >> 2;
                i = (u & 3) << 6 | a;
                t = t + String.fromCharCode(n);
                if (u != 64) { t = t + String.fromCharCode(r) }
                if (a != 64) { t = t + String.fromCharCode(i) }
            }
            t = Base64._utf8_decode(t);
            return t
        },
        _utf8_encode: function(e) {
            e = e.replace(/\r\n/g, "\n");
            var t = "";
            for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128)
                } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128)
                }
            }
            return t
        },
        _utf8_decode: function(e) {
            var t = "";
            var n = 0;
            var r = c1 = c2 = 0;
            while (n < e.length) {
                r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                    n++
                } else if (r > 191 && r < 224) {
                    c2 = e.charCodeAt(n + 1);
                    t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                    n += 2
                } else {
                    c2 = e.charCodeAt(n + 1);
                    c3 = e.charCodeAt(n + 2);
                    t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                    n += 3
                }
            }
            return t
        }
    }
    var codeSampleArray = ["php", "cs", "java", "rb", "py", "js"],
        codeSamplePath = ["php", "csharp", "java", "ruby", "python", "node"],
        sampleCodeView = undefined; //No default sample code to be shown now sampleCodeView = "php"; // initiate to view php


    // Set Proper Active Class For Tabs
    function setProperActiveClassForTabs(apiName, type) {
        var tabElements = document.querySelectorAll("ul[id^='" + apiName + "-myTab'] li");
        for (var i = 0; i < tabElements.length; i++) {
            tabElements[i].classList.remove('active');
        }
        switch (type) {
            case "extensionLiveConsole":
                tabElements[0].classList.add('active');
                break;
            case "extensionPhp":
                tabElements[1].classList.add('active');
                break;
            case "extensionCs":
                tabElements[2].classList.add('active');
                break;
            case "extensionJava":
                tabElements[3].classList.add('active');
                break;
            case "extensionRb":
                tabElements[4].classList.add('active');
                break;
            case "extensionPy":
                tabElements[5].classList.add('active');
                break;
            case "extensionJs":
                tabElements[6].classList.add('active');
                break;
        }
    }

    // Check if Live Console Tab is Active
    function checkIfTabIsActive(apiNameKey, tabName, $filter) {
        var tabElement = $filter('replaceSpace')(apiNameKey) + "-" + tabName;
        var element = document.getElementById(tabElement);
        if (element != null) {
            if (element.classList.contains("active")) {
                return true;
            }
            return false;
        }
        return false;
    }

    // This is a tricky case to initiate click event on changing of samples
    function initateCallAjax(apiNameKey, $scope, $filter) {
        if (!checkIfTabIsActive(apiNameKey, "LiveConsole", $filter)) {
            // Trigger click event for all the
            if (checkIfTabIsActive(apiNameKey, "Php", $filter)) {
                triggerClickEventSampleCodeTab(apiNameKey, "SamplePhp", $filter);
            } else if (checkIfTabIsActive(apiNameKey, "cs", $filter)) {
                triggerClickEventSampleCodeTab(apiNameKey, "SampleCs", $filter);
            } else if (checkIfTabIsActive(apiNameKey, "java", $filter)) {
                triggerClickEventSampleCodeTab(apiNameKey, "SampleJava", $filter);
            } else if (checkIfTabIsActive(apiNameKey, "ruby", $filter)) {
                triggerClickEventSampleCodeTab(apiNameKey, "SampleRb", $filter);
            } else if (checkIfTabIsActive(apiNameKey, "python", $filter)) {
                triggerClickEventSampleCodeTab(apiNameKey, "SamplePy", $filter);
            } else if (checkIfTabIsActive(apiNameKey, "node", $filter)) {
                triggerClickEventSampleCodeTab(apiNameKey, "SampleJs", $filter);
            }
        }
    }


    // Trigger Click event on the tab
    function triggerClickEventSampleCodeTab(apiNameKey, tabName, $scope, $filter) {
        var tabElement = $filter('replaceSpace')(apiNameKey) + tabName;
        var element = document.getElementById(tabElement);
        if (element != null) {
            $scope.$$postDigest(function() {
                element.click();
            });
        }
    }

    var sampleCodeClassList = [
        "extensionPhp", 
        "extensionCs", 
        "extensionJava", 
        "extensionRb", 
        "extensionPy", 
        "extensionJs", 
        "extensionLiveConsole"
];
    // Get sample code tab number
    function getSampleCodeTabNumber(classList) {

        if (sampleCodeClassList.includes(classList)) {
            return sampleCodeClassList.indexOf(classList);
        } else {
           return 6;
        }
    }

    var temporarySampleCodeHolder = "";

    function ajaxSuccess(returndata, extension, id, forbiddenUrl) {
        temporarySampleCodeHolder = "";

        if (returndata) {

            // Show code
            temporarySampleCodeHolder = Base64.decode(returndata.content);
            putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_VALUE',sampleCodeValue:temporarySampleCodeHolder});
            putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_ERROR',sampleCodeError:'No Error'});
            putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_URL',sampleCodeUrl: returndata.html_url})
        } else {
           
            putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_VALUE',sampleCodeValue:""});
            putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_ERROR',sampleCodeError:'Cannot fetch sample using Github API.  '});
        }

        return temporarySampleCodeHolder;

    }



    function sectionToFolder(sectionId) {
        return sectionId.underscoreToCamel().replace(/\s+/g, '').replace('-', '').replace('_', '');
    }

    

    function callAjax(extension, language, sectionId, apiName, fileName, sampleCodeComingSoon, apikey, apiSubSection) {

        // var repoOwner = "khaaldrogo";
        var repoOwner = "CyberSource";

        //Common constants
        var hostNameConstant = "https://api.github.com/repos";
        var cybsRepoNameStartConstant = "cybersource-rest-samples-";

        //Language wise constants
        var javafileApiPrefixConstant = "src/main/java/samples";
        var csharpfileApiPrefixConstant = "Source/Samples";
        var phpfileApiPrefixConstant = "Samples";
        var pythonfileApiPrefixConstant = "samples";
        var sampleCodeResponse = "";

        //Add folder name, and if applicable, additional folder path structure
        if (extension == "java") {
            if (apikey != undefined) {
                languagePrefixApiCategoryCoreServices = javafileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/" + sectionToFolder(apikey) + "/";
            } else {
                languagePrefixApiCategoryCoreServices = javafileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/";
            }
            fileName = fileName.replace(/[^0-9a-z]/gi, '');
            fileName = nameToCamelCase(fileName);
        } else if (extension == "cs") {
            if (apikey != undefined) {
                languagePrefixApiCategoryCoreServices = csharpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/" + sectionToFolder(apikey) + "/";
            } else {
                languagePrefixApiCategoryCoreServices = csharpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/";
            }
            fileName = fileName.replace(/[^0-9a-z]/gi, '');
            fileName = nameToCamelCase(fileName);
        } else if (extension == "py") {
            if (apikey != undefined) {
                languagePrefixApiCategoryCoreServices = pythonfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/" + sectionToFolder(apikey) + "/";
            } else {
                languagePrefixApiCategoryCoreServices = pythonfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/";
            }

            //File name to use underscore
            fileName = fileName.replace(/-/g, '-');
            fileName = fileName.replace(/[^0-9a-z-]/gi, '');
            fileName = fileName.replace(/-[-]+/gi, '-');
        } else if (extension == "php") {
            if (apikey != undefined) {
                languagePrefixApiCategoryCoreServices = phpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/" + sectionToFolder(apikey) + "/";
            } else {
                languagePrefixApiCategoryCoreServices = phpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/";
            }

            //File name to camel case in case of above three languages
            fileName = fileName.replace(/[^0-9a-z]/gi, '');
            fileName = nameToCamelCase(fileName);
        } else if (extension == "rb" || extension == "js") {
            if (apikey != undefined) {
                languagePrefixApiCategoryCoreServices = phpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/" + sectionToFolder(apikey) + "/";
            } else {
                languagePrefixApiCategoryCoreServices = phpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/";
            }

            //File name to camel case in case of above three languages
            fileName = fileName.replace(/-/g, '-');
            fileName = fileName.replace(/[^0-9a-z-]/gi, '');
            fileName = fileName.replace(/-[-]+/gi, '-');
        } else {
            if (apikey != undefined) {
                languagePrefixApiCategoryCoreServices = phpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/" + sectionToFolder(apikey) + "/";
            } else {
                languagePrefixApiCategoryCoreServices = phpfileApiPrefixConstant + "/" + sectionToFolder(sectionId) +
                    "/";
            }

            //File name to be camel case for any new languages
            fileName = fileName.replace(/[^0-9a-z]/gi, '');
            fileName = nameToCamelCase(fileName);
        }
        if (extension != undefined) {
            fileUrl = (hostNameConstant + "/" + repoOwner + "/") + (cybsRepoNameStartConstant + language) + "/contents/" +
                languagePrefixApiCategoryCoreServices + (fileName + "." + extension);
            $.support.cors = true; // need this for IE8/9 cross domain issue
            var gitRequestDataType = "json";
            var gitRequestTimeout = "5000";

            if ($.reviewSampleCodeSupport) {
                //Hitting Github directly encounters the same rate limit, as hitting via api.github.com
                fileUrl = ("https://github.com/" + "/" + repoOwner + "/") + (cybsRepoNameStartConstant + language) + "/blob/master/" + languagePrefixApiCategoryCoreServices + ("/" + fileName + "." + extension);
                gitRequestDataType = "jsonp";
                var gitRequestTimeout = "120000";
            }
            var dummyreturndata = {
                "name": "charge-credit-card.php",
                "path": "PaymentTransactions/charge-credit-card.php",
                "sha": "c05df536e83835ea22b152d89ea42c7b2d6fab58",
                "size": 6009,
                "url": "https://api.github.com/repos/AuthorizeNet/sample-code-php/contents/PaymentTransactions/charge-credit-card.php?ref=master",
                "html_url": "https://github.com/AuthorizeNet/sample-code-php/blob/master/PaymentTransactions/charge-credit-card.php",
                "git_url": "https://api.github.com/repos/AuthorizeNet/sample-code-php/git/blobs/c05df536e83835ea22b152d89ea42c7b2d6fab58",
                "download_url": "https://raw.githubusercontent.com/AuthorizeNet/sample-code-php/master/PaymentTransactions/charge-credit-card.php",
                "type": "file",
                "content": "PD9waHAKICByZXF1aXJlICd2ZW5kb3IvYXV0b2xvYWQucGhwJzsKICByZXF1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\nZ2VDcmVkaXRDYXJkKCIyLjIzIik7Cn0K\n",
                "encoding": "base64",
                "_links": {
                    "self": "https://api.github.com/repos/AuthorizeNet/sample-code-php/contents/PaymentTransactions/charge-credit-card.php?ref=master",
                    "git": "https://api.github.com/repos/AuthorizeNet/sample-code-php/git/blobs/c05df536e83835ea22b152d89ea42c7b2d6fab58",
                    "html": "https://github.com/AuthorizeNet/sample-code-php/blob/master/PaymentTransactions/charge-credit-card.php"
                }
            };

            // NOT REQUIRED: $("#showCode-"+ extension +"-"+apiName+" .CodeMirrorContainer").hide();

            $.ajax({
                url: fileUrl,
                dataType: gitRequestDataType,
                timeout: gitRequestTimeout,
                cache: false,
                success: function(returndata) {
                    // if ($.reviewSampleCodeSupport) {
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('background-color', 'green');

                    // console.log("Working: " + "#" + apiName + "Sample" + nameToCamelCase(extension));
                        //AddToSampleCodeReviewTable(apiName, fileName, textStatus.statusText);
                    // }

                    sampleCodeResponse = ajaxSuccess(returndata, extension, apiSubSection);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    /*if(language == "csharp")
                    {
                      ajaxSuccess(dummyreturndata, extension, apiName);
                      return;
                    }*/
                    
                    // if ($.reviewSampleCodeSupport) {
                    var response = JSON.parse(jqXHR.responseText);
                    if (textStatus.statusText == "success") {
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('background-color', 'green');

                        console.log("Working: " + "#" + apiName + "Sample" + nameToCamelCase(extension));
                        // AddToSampleCodeReviewTable(apiSubSection, fileName, textStatus.statusText);
                    } else if (textStatus.statusText == "Not Found" || (response.message && response.message === "Not Found")) {
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('background-color', 'red');
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('color', 'yellow');
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('font-weight', 'bold');
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('text-decoration', 'underline');

                        // AddToSampleCodeReviewTable(apiName, fileName, textStatus.statusText);
                        // $.notFoundSamples++;
                        putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_VALUE',sampleCodeValue:""});
                        putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_ERROR',sampleCodeError:"This language sample is unavailable. Please try a different language option."});
                        console.warn("Failing: " + "#" + apiName + "Sample" + nameToCamelCase(extension));
                        // console.log("Number of \"Not found\" samples confirmed: " + $.notFoundSamples);
                        // console.warn("Number of \"Not found\" samples confirmed: " + $.notFoundSamples);
                    } else if (textStatus.statusText == "rate limit exceeded" || (response.message && response.message.includes("API rate limit exceeded"))) {
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('background-color', 'grey');
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('color', 'black');
                        //Do not modify existing value of $.reviewSampleCodeTable[sectionId][fileName] in ambiguous cases
                        // if (undefined == $.reviewSampleCodeTable[sectionId] ||
                        //     undefined == $.reviewSampleCodeTable[sectionId][fileName]) {
                        //     AddToSampleCodeReviewTable(apiSubSection, fileName, textStatus.statusText);
                        // }
                        putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_VALUE',sampleCodeValue:""});
                        putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_ERROR',sampleCodeError:"Too many requests, please retry after some time."});
                        console.log("Retry after some time. Check this url: https://api.github.com/rate_limit");
                    } else {
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('background-color', 'brown');
                        // $("#" + apiSubSection + "Sample" + nameToCamelCase(extension)).css('color', 'black');
                        // //Do not modify existing value of $.reviewSampleCodeTable[sectionId][fileName] in ambiguous cases
                        // if (undefined == $.reviewSampleCodeTable[sectionId] ||
                        //     undefined == $.reviewSampleCodeTable[sectionId][fileName]) {
                        //     AddToSampleCodeReviewTable(apiSubSection, fileName, "Unknown");
                        // }
                        putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_VALUE',sampleCodeValue:""});
                        putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_ERROR',sampleCodeError:"Unknown error occured."});
                        console.warn("Unknown error occured.");
                    }
                    // }



                    // if (textStatus.statusText == "Forbidden") {
                    //     forbiddenFileUrl = ("https://github.com" + "/" + repoOwner + "/") + (cybsRepoNameStartConstant + language) + "/blob/master/" +
                    //         languagePrefixApiCategoryCoreServices + ("/" + fileName + "." + extension);
                    //     ajaxSuccess(null, extension, apiSubSection, forbiddenFileUrl);
                    // } else {
                    //     putDataInDevCenterDataStore({type:'UPDATE_SAMPLE_CODE_VALUE',sampleCodeValue:"Sample Code Coming Soon."});
                    //     ajaxFailure("", extension, apiSubSection, "<strong> Sample Code Coming Soon.</strong>", "red");
                    // }
                }
            });
        }
        return sampleCodeResponse;
    }

    // Initiate Sample Code Event  
    function initiateSampleCodeEvent(name, sectionNameForSamples, classList, apikey, examplefileName) {
        $.reviewSampleCodeSupport = false;
        $.reviewSampleCodeTable = {};
        $.notFoundSamples = 0;

        var apiSubSection = name;
        name = replaceStopWords(name);

        if (examplefileName != undefined) {
            examplefileName = examplefileName.replace(/[-&\/\\#,+()$~%.'":*?<>{}]/g, '');
            examplefileName = replaceStopWords(examplefileName);
            examplefileName = nameToCamelCase(examplefileName);
            name = examplefileName.trim();
        }


        if(name != undefined)
        {
            var apiName = name,
            nameDash = apiName.replace(/\-a-/g, '-').replace(/\-an-/g, '-').replace(/\-the-/g, '-'), // for name using "-"
            nameCamel = nameToCamelCase(nameDash), // for camel case

            sectionName = sectionNameForSamples,
            sectionId = nameToCamelCase(sectionName),
            fileName;

        var j;
        j = getSampleCodeTabNumber(classList);
        // if the sample code request is for c sharp or java 
        if (classList == "extensionCs" || classList == "extensionJava" || classList == "extensionPhp") {
            fileName = nameCamel.replace(/\s+/g, '');
        } else {
            fileName = nameDash.replace(/\s+/g, '-').toLowerCase();
        }
        fileName = replaceSpecialChars(fileName);
        callAjax(codeSampleArray[j], codeSamplePath[j], sectionId, apiName, fileName, false, apikey, apiSubSection);
        }
       
    }

    //Check if More Than One Api Sub Api Family Exists 
    function checkIfMoreThanOneApiSubApiFamilyExists(api, $scope) {
        return (Object.keys($scope.menuGroupsResponse[api]).length > 2);
    }

export default callAjax;
export {initiateSampleCodeEvent};